<template>
  <el-dialog custom-class="mini-dialog" title="采购价审核" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="采购单价" :label-width="formLabelWidth" prop="costprice">
            <el-input-number v-model="form.costprice" :controls="false" style="width: 150px" :min="0" @change="changNum"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="10">

        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="false">
        <el-col :span="10">
          <el-form-item label="核算单价" :label-width="formLabelWidth" prop="price">
            <el-input-number v-model="form.price" :controls="false" style="width: 150px" :min="0"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="10" >
          <el-form-item label="折扣" :label-width="formLabelWidth" >
            {{(form.price*10.00/form.costprice)|numeric(2)}}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {updatecostprice, getJxcformdetailGetList} from '@/api/set/csagreement';

  export default {
    name: "BuyUpdateCostPrice",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        form: {
          costprice:0,
          price:0,
          isgift:0,
          discount:0,
        },
        tabledata: {},
        seedcode: '',
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          costprice: [
            {required: true, message: '请输入采购单价', trigger: 'blur'},
          ],
          price: [
            {required: true, message: '请输入核算单价', trigger: 'blur'},
          ]
        },
      }
    },
    prop:{
      onlychangecost:false
    },
    methods: {
      changNum() {
          this.form.price = this.$numeric(this.form.costprice * this.form.discount, 3);
      },
      show(item) {
        this.initForm();
        this.tabledata = item
        getJxcformdetailGetList({erpserial: item.erpserial}).then(response => {
          if (response.data.obj.length > 0)
            this.seedcode = response.data.obj[0].seedcode
          this.form.totalnumber=response.data.obj[0].totalnumber;
          this.form.costprice =this.$numeric(response.data.obj[0].costtotalmoney /this.form.totalnumber,3);
          this.form.price =this.$numeric(response.data.obj[0].totalmoney /this.form.totalnumber,3);
          this.form.isgift =response.data.obj[0].isgift;
          this.form.discount=(this.form.price/this.form.costprice);
        })
        this.dialogFormVisible = true;
      },
      saveData() {
        // this.$confirm('确认修改价格吗？', '提示', {
        //   confirmButtonText: '确定',
        //   type: 'warning'
        // }).then(() => {
          this.$refs.form1.validate((valid) => {
            if (valid) {
              updatecostprice({
                erpserial: this.tabledata.erpserial,
                costprice: this.form.costprice,
                price: this.form.price,
                seedcode: this.seedcode,
                unitguid: this.tabledata.unitguid,
                packagesize: '',
                invoicesource: 2,
              }).then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    message: "审核通过",
                    type: 'success'
                  })
                  this.dialogFormVisible = false
                  //刷新列表
                  this.$emit("bindGrid")
                } else {
                  this.$message({
                    message: "审核失败",
                    type: 'error'
                  })
                }
              });
            }
          });
        // }).catch(() => {
        //
        // });

      },
      initForm() {
      }
    },
    mounted() {
    },
    components: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyUpdateCostPrice.vue